import { Seo } from "@/components/Seo";
import { Link } from "react-router-dom";
import { Sparkles, Leaf, FlaskConical, Heart, Globe, ArrowRight, Quote } from "lucide-react";

export default function About() {
  return (
    <>
      <Seo title="Giới thiệu LumiSkin | Câu chuyện thương hiệu" description="LumiSkin – thương hiệu chăm sóc da thuần chay, tối giản và hiệu quả. Khám phá câu chuyện, giá trị và sứ mệnh của chúng tôi." />

      {/* HERO – mở đầu bằng TIÊU ĐỀ TRONG Ô ĐẦU, texture tex-grid bắt buộc */}
      <section data-upbo-src="src/pages/About.tsx:11" className="section-hero tex-grid">
        <div data-upbo-src="src/pages/About.tsx:12" className="container-page">
          <div data-upbo-src="src/pages/About.tsx:13" className="grid gap-8 lg:grid-cols-12 lg:items-end">
            <div data-upbo-src="src/pages/About.tsx:14" className="lg:col-span-7">
              <p data-upbo-src="src/pages/About.tsx:15" className="eyebrow mb-6">Thương hiệu LumiSkin · Est. 2021</p>
              <h1 data-upbo-src="src/pages/About.tsx:16" className="text-[clamp(3rem,8vw,6rem)] font-bold leading-none tracking-tight">
                Sự sáng bắt nguồn từ{" "}
                <span data-upbo-src="src/pages/About.tsx:18" className="border-b-4 border-[var(--color-accent)] pb-1">
                  bên trong
                </span>
              </h1>
            </div>
            <div data-upbo-src="src/pages/About.tsx:23" className="lg:col-span-5">
              <p data-upbo-src="src/pages/About.tsx:24" className="measure text-lg leading-relaxed text-[var(--color-muted)]">
                Chúng tôi tin rằng làn da khoẻ là nền tảng của vẻ đẹp đích thực. LumiSkin ra đời để loại bỏ sự ồn ào trong ngành mỹ phẩm và trao cho bạn những sản phẩm tinh khiết, tối giản và thực sự hiệu quả.
              </p>
              <div data-upbo-src="src/pages/About.tsx:27" className="mt-8 flex flex-wrap gap-4">
                <Link
                  to="/shop"
                  className="inline-flex items-center gap-2 rounded-[var(--radius)] bg-[var(--color-accent)] px-6 py-3 font-semibold text-white transition hover:bg-black"
                >
                  Khám phá sản phẩm <ArrowRight className="h-4 w-4" />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 rounded-[var(--radius)] border border-[var(--color-border)] px-6 py-3 font-semibold transition hover:border-black hover:bg-black hover:text-white"
                >
                  Liên hệ với chúng tôi
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CÂU CHUYỆN – mở đầu bằng HỎI – ĐÁP */}
      <section data-upbo-src="src/pages/About.tsx:47" className="section">
        <div data-upbo-src="src/pages/About.tsx:48" className="container-page">
          <div data-upbo-src="src/pages/About.tsx:49" className="grid gap-12 lg:grid-cols-2 lg:items-start">
            <div data-upbo-src="src/pages/About.tsx:50">
              <p data-upbo-src="src/pages/About.tsx:51" className="eyebrow mb-4">Tại sao LumiSkin khác biệt?</p>
              <h2 data-upbo-src="src/pages/About.tsx:52" className="text-[clamp(1.75rem,3.5vw,2.25rem)] font-semibold leading-tight tracking-tight">
                Bởi chúng tôi tin rằng sự rạng rỡ đến từ làn da khoẻ, không phải lớp trang điểm che phủ.
              </h2>
            </div>
            <div data-upbo-src="src/pages/About.tsx:56" className="space-y-6 text-[var(--color-muted)]">
              <p data-upbo-src="src/pages/About.tsx:57" className="measure">
                LumiSkin khởi nguồn từ một câu hỏi đơn giản: tại sao làn da của chúng ta ngày càng nhạy cảm và yếu ớt? Câu trả lời nằm ở hàng loạt hoá chất tẩy rửa mạnh và thành phần không cần thiết trong các sản phẩm thông thường.
              </p>
              <p data-upbo-src="src/pages/About.tsx:60" className="measure">
                Chúng tôi quyết định làm khác đi. Mỗi công thức LumiSkin đều được tối giản đến mức tối đa, chỉ giữ lại những hoạt chất đã được chứng minh khoa học, ở nồng độ phù hợp, không hương liệu, không chất tạo màu, không chất bảo quản gây kích ứng.
              </p>
              <div data-upbo-src="src/pages/About.tsx:63" className="rule" />
              <div data-upbo-src="src/pages/About.tsx:64" className="flex items-center gap-3">
                <Quote className="h-5 w-5 text-[var(--color-muted)]" />
                <p data-upbo-src="src/pages/About.tsx:66" className="text-sm italic">
                  “Tôi không muốn làn da của mình phụ thuộc vào mỹ phẩm. Tôi muốn nó tự khoẻ.” – Nhà sáng lập
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GIÁ TRỊ – TIÊU ĐỀ TRONG Ô ĐẦU + BENTO GRID */}
      <section data-upbo-src="src/pages/About.tsx:76" className="section border-t border-[var(--color-border)]">
        <div data-upbo-src="src/pages/About.tsx:77" className="container-page">
          <div data-upbo-src="src/pages/About.tsx:78" className="grid gap-10 lg:grid-cols-12">
            <div data-upbo-src="src/pages/About.tsx:79" className="lg:col-span-4">
              <h2 data-upbo-src="src/pages/About.tsx:80" className="text-[clamp(1.75rem,3.5vw,2.25rem)] font-semibold leading-tight tracking-tight">
                Bốn trụ cột làm nên LumiSkin
              </h2>
              <p data-upbo-src="src/pages/About.tsx:83" className="mt-4 measure-tight text-[var(--color-muted)]">
                Đây không phải khẩu hiệu – đây là nguyên tắc chúng tôi áp dụng cho từng sản phẩm.
              </p>
            </div>
            <div data-upbo-src="src/pages/About.tsx:87" className="lg:col-span-8">
              <div data-upbo-src="src/pages/About.tsx:88" className="grid grid-cols-2 gap-px bg-[var(--color-border)] border border-[var(--color-border)]">
                <div data-upbo-src="src/pages/About.tsx:89" className="col-span-2 bg-[var(--color-bg)] p-6 transition hover:bg-black hover:text-white group">
                  <h3 data-upbo-src="src/pages/About.tsx:90" className="text-lg font-semibold">Thuần chay & nhân đạo</h3>
                  <p data-upbo-src="src/pages/About.tsx:91" className="mt-2 text-sm text-[var(--color-muted)] group-hover:text-gray-300">
                    Không thành phần động vật, không thử nghiệm trên động vật. Cam kết môi trường.
                  </p>
                </div>
                <div data-upbo-src="src/pages/About.tsx:95" className="bg-[var(--color-bg)] p-6 transition hover:bg-black hover:text-white group">
                  <h3 data-upbo-src="src/pages/About.tsx:96" className="text-lg font-semibold">Tối giản công thức</h3>
                  <p data-upbo-src="src/pages/About.tsx:97" className="mt-2 text-sm text-[var(--color-muted)] group-hover:text-gray-300">
                    Trung bình dưới 15 nguyên liệu, ưu tiên hoạt chất đa năng.
                  </p>
                </div>
                <div data-upbo-src="src/pages/About.tsx:101" className="bg-[var(--color-bg)] p-6 transition hover:bg-black hover:text-white group">
                  <h3 data-upbo-src="src/pages/About.tsx:102" className="text-lg font-semibold">Minh bạch tuyệt đối</h3>
                  <p data-upbo-src="src/pages/About.tsx:103" className="mt-2 text-sm text-[var(--color-muted)] group-hover:text-gray-300">
                    Công bố đầy đủ nồng độ, nguồn gốc và chứng nhận của mọi thành phần.
                  </p>
                </div>
                <div data-upbo-src="src/pages/About.tsx:107" className="col-span-2 bg-[var(--color-bg)] p-6 transition hover:bg-black hover:text-white group">
                  <h3 data-upbo-src="src/pages/About.tsx:108" className="text-lg font-semibold">Hiệu quả lâm sàng</h3>
                  <p data-upbo-src="src/pages/About.tsx:109" className="mt-2 text-sm text-[var(--color-muted)] group-hover:text-gray-300">
                    Mỗi sản phẩm đều trải qua nghiên cứu lâm sàng và được kiểm nghiệm độc lập bởi phòng lab quốc tế.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THỐNG KÊ – SỐ THỨ TỰ KHỔ LỚN (watermark) + texture tex-dots */}
      <section data-upbo-src="src/pages/About.tsx:120" className="section-tight tex-dots border-y border-[var(--color-border)]">
        <div data-upbo-src="src/pages/About.tsx:121" className="container-page">
          <div data-upbo-src="src/pages/About.tsx:122" className="relative">
            <span data-upbo-src="src/pages/About.tsx:123" className="watermark absolute -top-8 left-0 text-[10rem] font-bold opacity-10" aria-hidden="true">
              01
            </span>
            <div data-upbo-src="src/pages/About.tsx:126" className="relative pl-16 sm:pl-24">
              <h2 data-upbo-src="src/pages/About.tsx:127" className="text-[clamp(1.75rem,3.5vw,2.25rem)] font-semibold leading-tight tracking-tight">
                Những con số biết nói
              </h2>
            </div>
          </div>
          <div data-upbo-src="src/pages/About.tsx:132" className="mt-12 grid grid-cols-2 gap-8 md:grid-cols-4">
            <div data-upbo-src="src/pages/About.tsx:133">
              <div data-upbo-src="src/pages/About.tsx:134" className="text-4xl font-bold tracking-tight">50K+</div>
              <p data-upbo-src="src/pages/About.tsx:135" className="mt-2 text-sm text-[var(--color-muted)]">Khách hàng tin dùng</p>
            </div>
            <div data-upbo-src="src/pages/About.tsx:137">
              <div data-upbo-src="src/pages/About.tsx:138" className="text-4xl font-bold tracking-tight">98%</div>
              <p data-upbo-src="src/pages/About.tsx:139" className="mt-2 text-sm text-[var(--color-muted)]">Cảm nhận làn da cải thiện sau 4 tuần</p>
            </div>
            <div data-upbo-src="src/pages/About.tsx:141">
              <div data-upbo-src="src/pages/About.tsx:142" className="text-4xl font-bold tracking-tight">12</div>
              <p data-upbo-src="src/pages/About.tsx:143" className="mt-2 text-sm text-[var(--color-muted)]">Sản phẩm chuyên biệt</p>
            </div>
            <div data-upbo-src="src/pages/About.tsx:145">
              <div data-upbo-src="src/pages/About.tsx:146" className="text-4xl font-bold tracking-tight">4.9/5</div>
              <p data-upbo-src="src/pages/About.tsx:147" className="mt-2 text-sm text-[var(--color-muted)]">Đánh giá trung bình từ người dùng</p>
            </div>
          </div>
        </div>
      </section>

      {/* QUY TRÌNH – STICKY SIDE HEADING */}
      <section data-upbo-src="src/pages/About.tsx:154" className="section">
        <div data-upbo-src="src/pages/About.tsx:155" className="container-page">
          <div data-upbo-src="src/pages/About.tsx:156" className="grid gap-12 lg:grid-cols-[1fr_2fr]">
            <div data-upbo-src="src/pages/About.tsx:157" className="lg:sticky lg:top-28 self-start">
              <p data-upbo-src="src/pages/About.tsx:158" className="eyebrow mb-4">Quy trình của chúng tôi</p>
              <h2 data-upbo-src="src/pages/About.tsx:159" className="text-[clamp(1.75rem,3.5vw,2.25rem)] font-semibold leading-tight tracking-tight">
                Từ phòng lab đến làn da bạn
              </h2>
            </div>
            <div data-upbo-src="src/pages/About.tsx:163" className="space-y-0">
              {[
                {
                  icon: FlaskConical,
                  title: "Nghiên cứu & phát triển",
                  desc: "Hợp tác với các nhà khoa học da liễu, sàng lọc hàng trăm hoạt chất, thử nghiệm in-vitro."
                },
                {
                  icon: Leaf,
                  title: "Công thức tối giản",
                  desc: "Loại bỏ mọi thành phần không cần thiết, giữ lại nồng độ tối ưu của hoạt chất chính."
                },
                {
                  icon: Heart,
                  title: "Kiểm nghiệm an toàn",
                  desc: "Thử nghiệm lâm sàng trên da nhạy cảm, đánh giá độ kích ứng và hiệu quả trong 12 tuần."
                },
                {
                  icon: Globe,
                  title: "Sản xuất bền vững",
                  desc: "Đóng gói tái chế, giảm thiểu carbon, vận chuyển trung hoà."
                }
              ].map((step, i) => {
                const Icon = step.icon;
                return (
                  <div data-upbo-src="src/pages/About.tsx:188" key={i} className="border-t border-[var(--color-border)] py-6 first:border-t-0 first:pt-0">
                    <div data-upbo-src="src/pages/About.tsx:189" className="flex items-start gap-4">
                      <div data-upbo-src="src/pages/About.tsx:190" className="mt-1 flex h-10 w-10 items-center justify-center rounded-full border border-[var(--color-border)]">
                        <Icon className="h-5 w-5" />
                      </div>
                      <div data-upbo-src="src/pages/About.tsx:193">
                        <h3 data-upbo-src="src/pages/About.tsx:194" className="text-lg font-semibold">{step.title}</h3>
                        <p data-upbo-src="src/pages/About.tsx:195" className="mt-1 text-sm text-[var(--color-muted)]">{step.desc}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* EDGE-BLEED PANEL – tuyên ngôn */}
      <section data-upbo-src="src/pages/About.tsx:207" className="section-flush">
        <div data-upbo-src="src/pages/About.tsx:208" className="edge-bleed bg-[var(--color-accent)] py-20 text-white">
          <div data-upbo-src="src/pages/About.tsx:209" className="container-page">
            <div data-upbo-src="src/pages/About.tsx:210" className="grid gap-8 lg:grid-cols-12 lg:items-center">
              <div data-upbo-src="src/pages/About.tsx:211" className="lg:col-span-8">
                <p data-upbo-src="src/pages/About.tsx:212" className="eyebrow text-white/60 mb-4">Tuyên ngôn</p>
                <p data-upbo-src="src/pages/About.tsx:213" className="text-2xl font-semibold leading-snug md:text-3xl">
                  “Chúng tôi không hứa hẹn phép màu. Chúng tôi hứa hẹn sự kiên nhẫn, khoa học và một làn da khoẻ mạnh dần lên từng ngày.”
                </p>
              </div>
              <div data-upbo-src="src/pages/About.tsx:217" className="lg:col-span-4">
                <Link
                  to="/shop"
                  className="inline-flex items-center gap-2 rounded-[var(--radius)] bg-white px-6 py-3 font-semibold text-black transition hover:bg-gray-200"
                >
                  Bắt đầu hành trình <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CHỨNG NHẬN & THÀNH PHẦN – mở đầu bằng luật + nhãn bên lề */}
      <section data-upbo-src="src/pages/About.tsx:231" className="section border-t border-[var(--color-border)]">
        <div data-upbo-src="src/pages/About.tsx:232" className="container-page">
          <div data-upbo-src="src/pages/About.tsx:233" className="rule mb-12" />
          <div data-upbo-src="src/pages/About.tsx:234" className="grid gap-12 lg:grid-cols-3">
            <div data-upbo-src="src/pages/About.tsx:235" className="lg:col-span-1">
              <p data-upbo-src="src/pages/About.tsx:236" className="eyebrow mb-2">Cam kết</p>
              <h2 data-upbo-src="src/pages/About.tsx:237" className="text-2xl font-semibold tracking-tight">
                Điều chúng tôi không bao giờ đánh đổi
              </h2>
            </div>
            <div data-upbo-src="src/pages/About.tsx:241" className="lg:col-span-2">
              <dl data-upbo-src="src/pages/About.tsx:242" className="divide-y divide-[var(--color-border)] border-y border-[var(--color-border)]">
                <div data-upbo-src="src/pages/About.tsx:243" className="flex justify-between py-4">
                  <dt data-upbo-src="src/pages/About.tsx:244" className="text-sm font-medium text-[var(--color-muted)]">Paraben</dt>
                  <dd data-upbo-src="src/pages/About.tsx:245" className="text-sm font-semibold">Không bao giờ</dd>
                </div>
                <div data-upbo-src="src/pages/About.tsx:247" className="flex justify-between py-4">
                  <dt data-upbo-src="src/pages/About.tsx:248" className="text-sm font-medium text-[var(--color-muted)]">Sulfate</dt>
                  <dd data-upbo-src="src/pages/About.tsx:249" className="text-sm font-semibold">Không bao giờ</dd>
                </div>
                <div data-upbo-src="src/pages/About.tsx:251" className="flex justify-between py-4">
                  <dt data-upbo-src="src/pages/About.tsx:252" className="text-sm font-medium text-[var(--color-muted)]">Hương liệu tổng hợp</dt>
                  <dd data-upbo-src="src/pages/About.tsx:253" className="text-sm font-semibold">Không bao giờ</dd>
                </div>
                <div data-upbo-src="src/pages/About.tsx:255" className="flex justify-between py-4">
                  <dt data-upbo-src="src/pages/About.tsx:256" className="text-sm font-medium text-[var(--color-muted)]">Dầu khoáng</dt>
                  <dd data-upbo-src="src/pages/About.tsx:257" className="text-sm font-semibold">Không bao giờ</dd>
                </div>
                <div data-upbo-src="src/pages/About.tsx:259" className="flex justify-between py-4">
                  <dt data-upbo-src="src/pages/About.tsx:260" className="text-sm font-medium text-[var(--color-muted)]">Chất tạo màu</dt>
                  <dd data-upbo-src="src/pages/About.tsx:261" className="text-sm font-semibold">Không bao giờ</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>

      {/* CTA CUỐI – khối căn giữa duy nhất */}
      <section data-upbo-src="src/pages/About.tsx:270" className="section text-center">
        <div data-upbo-src="src/pages/About.tsx:271" className="container-page">
          <p data-upbo-src="src/pages/About.tsx:272" className="eyebrow mb-4">Sẵn sàng thay đổi?</p>
          <h2 data-upbo-src="src/pages/About.tsx:273" className="text-[clamp(1.75rem,3.5vw,2.25rem)] font-semibold leading-tight tracking-tight">
            Làn da khoẻ bắt đầu từ hôm nay
          </h2>
          <p data-upbo-src="src/pages/About.tsx:276" className="mx-auto mt-4 max-w-[46ch] text-[var(--color-muted)]">
            Khám phá bộ sưu tập tinh gọn của chúng tôi – mỗi sản phẩm là một bước tiến nhỏ cho làn da của bạn.
          </p>
          <Link
            to="/shop"
            className="mt-8 inline-flex items-center gap-2 rounded-[var(--radius)] bg-[var(--color-accent)] px-8 py-4 font-semibold text-white transition hover:bg-black"
          >
            Mua sắm ngay <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </>
  );
}
